module.exports = __webpack_public_path__ + "img/button_sports_off.cf781b10.png";